import styled from "styled-components";
import ADD_RED_SVG from "assets/images/add_red.svg";
import FILE_UPLOAD_SVG from "assets/images/upload.svg";
import { video } from "shared/types/Report";
import {
    EditorTableWrap, EditorTable, EditorThead, EditorTbody, EditorTfoot, EditorTrHead, EditorTr, EditorTd, EditorTh,
    EditorScroll, EditorInput, EditorIconBtn, EditorCheck, EditorVideoThumb, TableEmpty
} from "../homeworkUi";

interface VideoTableProps{
    list: video[],
    selectedList: number[],
    onAddClickHandler: () => void,
    onChangeHandler: (index: number, name: string, value: string) => void
    onSelectHandler: (id:number, value:boolean) => void,
    onSelectAllClickHandler: (value:boolean) => void,
    videoInputRefs: React.RefObject<(HTMLInputElement | null)[]>,
    onVideoChangeHandler: (index: number, event: React.ChangeEvent<HTMLInputElement>, audio:boolean) => void;
    onVideoInputClickHandler:(index: number, audio:boolean) => void,
    onFileClickHandler: (url:string, index:number, type:string, audio:boolean) => void,
    onSelectReadOnlyClickHandler: (index:number, event:React.ChangeEvent<HTMLInputElement>) => void
}

const VideoTable = ({list, selectedList, onAddClickHandler, onChangeHandler, onSelectAllClickHandler, onSelectHandler, videoInputRefs, onVideoChangeHandler, onVideoInputClickHandler, onFileClickHandler, onSelectReadOnlyClickHandler}:VideoTableProps) => {
    const renderVideoPreview = (item:video, index:number) => {
        if(item.video_preview){
            return <EditorVideoThumb src={item.video_preview} onClick={() => {
                if(item.video_preview){
                    onFileClickHandler(item.video_preview, index, "video", true)
                }
            }}/>
        }
        if(item.video){
            const videoUrl = typeof item.video === 'string' ? item.video : "";
            return <EditorVideoThumb src={videoUrl} onClick={() => {
                onFileClickHandler(videoUrl, index, "video", true)
            }}/>
        }
        return (
            <>
                <HiddenInput accept="video/*" type="file" ref={(el) => { if(videoInputRefs.current) {videoInputRefs.current[index] = el;}}} onChange={(e) => onVideoChangeHandler(index, e, true)}/>
                <EditorIconBtn src={FILE_UPLOAD_SVG} alt="add_img" onClick={() => onVideoInputClickHandler(index, true)} />
            </>
        );
    }

    const viewVideoList = () => {
        if (!list.length) {
            return (
                <EditorTr>
                    <EditorTd colSpan={6}>
                        <TableEmpty>아직 영상이 없습니다. 아래 + 버튼으로 추가하거나 일괄등록을 사용하세요.</TableEmpty>
                    </EditorTd>
                </EditorTr>
            );
        }
        return list.map((item, index) => (
            <EditorTr key={index + 1}>
                <EditorTd style={{ width: "6%" }}>{index + 1}</EditorTd>
                <EditorTd style={{ width: "32%" }}>
                    <EditorInput name="title" value={item.title} onChange={(e) => onChangeHandler(index, e.target.name, e.target.value)} placeholder="제목을 입력해 주세요"/>
                </EditorTd>
                <EditorTd style={{ width: "32%" }}>
                    <EditorInput name="example" value={item.example} onChange={(e) => onChangeHandler(index, e.target.name, e.target.value)} placeholder="예문을 입력해 주세요"/>
                </EditorTd>
                <EditorTd style={{ width: "12%" }}>{renderVideoPreview(item, index)}</EditorTd>
                <EditorTd style={{ width: "10%" }}>
                    <EditorCheck type="checkbox" checked={item.read_only} onChange={(e) => onSelectReadOnlyClickHandler(index, e)}/>
                </EditorTd>
                <EditorTd style={{ width: "8%" }}>
                    <EditorCheck type="checkbox" checked={selectedList.includes(item.id)} onChange={(e) => onSelectHandler(item.id, e.target.checked)}/>
                </EditorTd>
            </EditorTr>
        ));
    }

    return(
        <EditorTableWrap>
            <EditorTable>
                <EditorThead>
                    <EditorTrHead>
                        <EditorTh style={{ width: "6%" }}>번호</EditorTh>
                        <EditorTh style={{ width: "32%" }}>제목</EditorTh>
                        <EditorTh style={{ width: "32%" }}>예문</EditorTh>
                        <EditorTh style={{ width: "12%" }}>영상</EditorTh>
                        <EditorTh style={{ width: "10%" }}>보기 전용</EditorTh>
                        <EditorTh style={{ width: "8%" }}>
                            <EditorCheck type="checkbox" onChange={(e) => {onSelectAllClickHandler(e.target.checked)}}/>
                        </EditorTh>
                    </EditorTrHead>
                </EditorThead>
            </EditorTable>
            <EditorScroll>
                <EditorTable>
                    <EditorTbody>
                        {viewVideoList()}
                    </EditorTbody>
                </EditorTable>
            </EditorScroll>
            <EditorTable>
                <EditorTfoot>
                    <EditorTr>
                        <EditorTd colSpan={6}><EditorIconBtn src={ADD_RED_SVG} alt="add" onClick={onAddClickHandler} /></EditorTd>
                    </EditorTr>
                </EditorTfoot>
            </EditorTable>
        </EditorTableWrap>
    )
}

const HiddenInput = styled.input`
    display: none;
`;

export default VideoTable;
